import { Box, Grid, Typography } from '@mui/material';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import React, { useEffect, useState } from 'react';
import { Gridstyles } from './index';
import { Applicant, Broker, BrokerList, DPNameType } from '../../redux-store/types/api-types';
import {
  CKYC_SELECTION_OPTIONS_OBJECT,
  DematDetialsValidationModified,
  DLCLMasters,
  otherOccupationStartDate,
  PAN_AADHAAR_MASTER,
  SOURCE_OF_FUNDS_MASTER,
  YES_NO_BOOLEAN_MASTER,
  YES_NO_MASTER,
} from '../../utils/constant';
import {
  getclIdField,
  getdpIdField,
  isFirstApplicant,
  isOtherSourceOfFund,
  isCDSL,
  checkValidationBasedOnDate,
  isOtherOccupation,
} from '../../utils/utilityFunctions';
import { styles } from '../../Styles/styles';
import { useMdmsBrokerListData } from '../../utils/useDataMdms';
import { getDPNameList } from '../../redux-store/actions/userManagement';
import { useDispatch } from 'react-redux';

export default function KycDetails({
  applicants = [],
  createdAt = '',
}: {
  applicants: Partial<Applicant>[];
  createdAt: string;
}): JSX.Element {
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const { BrokerList } = useMdmsBrokerListData();
  const dispatch = useDispatch();
  const [dpbrokerList, dpsetBrokerList] = useState<DPNameType[]>([]);
  useEffect(() => {
    (async function () {
      try {
        setBrokerList(BrokerList as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [BrokerList]);

  useEffect(() => {
    const fetchBrokerList = async () => {
      try {
        const response = (await dispatch(getDPNameList())) as unknown as DPNameType[];
        dpsetBrokerList(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    };

    fetchBrokerList();
  }, []);

  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Additional KYC Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={15}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Occupation Details'}
                        description={
                          isOtherOccupation(applicant.occupationDetails || '') &&
                          checkValidationBasedOnDate(createdAt || '', otherOccupationStartDate)
                            ? applicant.otherOccupationDetails
                            : applicant.occupationDetails
                        }
                      />
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      {/* <KeyValue
                        title={'Net-Worth (Mandatory For Non-Individuals)'}
                        description={applicant.netWorth}
                      />
                      <KeyValue
                        title={'Net Worth Date'}
                        description={formatShortDate(applicant.netWorthDate)}
                      /> */}
                      <KeyValue
                        title={'Politically Exposed Person (PEP) Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />

                      <KeyValue
                        title={'CKYC selection options'}
                        description={
                          CKYC_SELECTION_OPTIONS_OBJECT[applicant.ckyc_selection_options || '']
                        }
                      />
                      <KeyValue title={'CKYC Number'} description={applicant.ckycNo} />
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={
                            isCDSL(applicant.dlclId || '') &&
                            !checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)
                              ? 'DPCL ID'
                              : 'DP ID'
                          }
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '', createdAt) && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {/* {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            brokerList?.broker_list.find(
                              (broker) => broker.key === applicant.nameOfBroker
                            )?.value
                          }
                        />
                      )} */}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title="Name of Broker/Depository Participant (DP)"
                          description={
                            dpbrokerList.find(
                              (broker: DPNameType) =>
                                Number(broker.id) === Number(applicant.broker_id)
                            )?.brokerName || 'N/A'
                          }
                        />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name as per the Demat Account'}
                          description={applicant.dematName}
                        />
                      )}
                      {isFirstApplicant(applicant?.applicant_type || '') && (
                        <KeyValue
                          title={'AMC Call Verified?'}
                          description={YES_NO_MASTER[applicant.amcCallVerified || '']}
                        />
                      )}
                      <KeyValue
                        title={'Source Of Funds'}
                        description={
                          isOtherSourceOfFund(applicant.sourceOfFunds || '')
                            ? applicant.sourceOfFunds
                            : SOURCE_OF_FUNDS_MASTER[applicant.sourceOfFunds || '']
                        }
                      />
                      <KeyValue
                        title={'KYC Compliant'}
                        description={
                          YES_NO_BOOLEAN_MASTER[applicant.dataFetchedFromKRA?.toString() || '']
                        }
                      />
                      <KeyValue
                        title={'PAN/Aadhaar Linked'}
                        description={PAN_AADHAAR_MASTER[applicant.panAadhaarLinked || '']}
                      />
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
